import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from "../../redux/index";
import { Link } from 'react-router-dom';
import moneyFormat from '../functions/moneyFormat';
import { TableCell } from '@mui/material';

const ConsortiumViewRow = ({ row, count, tableHeader,stickyEnabled }) => {
    // get redux persistant state from redux store 
    const company = useSelector((state) => state.company);
    const companyInfo = useSelector((state) => state.companyInfo);
    const dispatch = useDispatch();
    const { setCompany, setCompanyInfo } = bindActionCreators(actionCreators, dispatch);
    // event handler when company link is clicked 
    const onCompanyClick = (e) =>{
        console.log(row);
        // set company state to bring to new route (CompanyPagoutViewPage)
        setCompany(e.target.innerText.toString());
        setCompanyInfo(row);
    }

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }

    return (    
        <>
            {tableHeader.map(el =>
                // show link on company name 
                el['columnname'] == 'mastercompanyname' ?
                <TableCell className={getRowClassName(el['columnorder'])}>
                    {/* only show link if user is entitled */}
                    {row['userroleid'] ? 
                        <Link onClick={(e)=>onCompanyClick(e)}
                            to={{
                                pathname: "/CompanyPayoutViewPage",
                            }}>
                            {row[el['columnname']]}
                        </Link>
                    : <> {row[el['columnname']]} </> }
                </TableCell>       
                // logic to apply money format to correct rows
                : el['columnname'] == 'cyclegrossspend' || el['columnname'] == 'cyclegrossinterchange' 
                || el['columnname'] == 'ytdgrossspend' || el['columnname'] == 'ytdgrossinterchange' ?
                    <> 
                        {row[el['columnname']] == null ?
                            <TableCell className={getRowClassName(el['columnorder'])} align='right'>None</TableCell>
                        :<TableCell className={getRowClassName(el['columnorder'])} align='right'>{moneyFormat(row[el['columnname']])}</TableCell>}
                    </>
                // standard display for other cols
                : <> {row[el['columnname']] == null ?
                        <TableCell className={getRowClassName(el['columnorder'])}>None</TableCell>
                :<TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>}
                </>
            )}
        </>
    ); 
}

export default ConsortiumViewRow; 